// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../rescript/lib/es6/curry.js";
import * as Json__Decode from "../../../../../rescript-json/lib/es6_global/src/Json__Decode.bs.js";
import * as Facets$ApiTypes from "../Facets.bs.js";
import * as Generic$ApiTypes from "../utils/Generic.bs.js";
import * as ThemeDecoders$ApiTypes from "../ThemeDecoders.bs.js";
import * as CustomActionId$ApiTypes from "../CustomActionId.bs.js";
import * as EmbedCodeCodecs$ApiTypes from "../EmbedCodeCodecs.bs.js";
import * as QuickViewPinCodecs$ApiTypes from "../QuickViewPinCodecs.bs.js";
import * as CustomComponentCodecs$ApiTypes from "../CustomComponentCodecs.bs.js";
import * as Tree_TaggedMediaCodecs$ApiTypes from "../Tree/Tree_TaggedMediaCodecs.bs.js";
import * as Tree_TaggedProductsCodecs$ApiTypes from "../Tree/Tree_TaggedProductsCodecs.bs.js";
import * as Tree_DisplayPriorityCodecs$ApiTypes from "../Tree/Tree_DisplayPriorityCodecs.bs.js";
import * as Store_ProductSortOrderCodecs$ApiTypes from "../Store/Store_ProductSortOrderCodecs.bs.js";
import * as Store_ProductSortOrderDecoders$ApiTypes from "../Store/Store_ProductSortOrderDecoders.bs.js";
import * as Tree_CategoryTabSettingsCodecs$ApiTypes from "../Tree/Tree_CategoryTabSettingsCodecs.bs.js";
import * as Tree_SocialNetworkSourceCodecs$ApiTypes from "../Tree/Tree_SocialNetworkSourceCodecs.bs.js";
import * as LegacyShowside_BasicTypesDecoders$ApiTypes from "./LegacyShowside_BasicTypesDecoders.bs.js";

var fromJson = Generic$ApiTypes.Decode.simpleVariant([
      [
        "Xxxs",
        /* Xxxs */0
      ],
      [
        "Xxs",
        /* Xxs */1
      ],
      [
        "Xs",
        /* Xs */2
      ],
      [
        "Sm",
        /* Sm */3
      ],
      [
        "Md",
        /* Md */4
      ],
      [
        "Lg",
        /* Lg */5
      ],
      [
        "Xl",
        /* Xl */6
      ],
      [
        "Xxl",
        /* Xxl */7
      ],
      [
        "Xxxl",
        /* Xxxl */8
      ],
      [
        "Xxxxl",
        /* Xxxxl */9
      ],
      [
        "Xxxxxl",
        /* Xxxxxl */10
      ]
    ]);

var CardSize = {
  fromJson: fromJson
};

var categoryLink_fromJson = Curry._3(Generic$ApiTypes.Decode.map2, Curry._2(Generic$ApiTypes.Decode.field, "categoryId", Generic$ApiTypes.Decode.string), Generic$ApiTypes.Decode.fieldWithDefault("filters", Curry._1(Generic$ApiTypes.Decode.option, Facets$ApiTypes.fromJson), undefined), (function (categoryId, filters) {
        return {
                categoryId: categoryId,
                filters: filters
              };
      }));

var productLink_fromJson = Curry._4(Generic$ApiTypes.Decode.map3, Curry._2(Generic$ApiTypes.Decode.field, "productId", Generic$ApiTypes.Decode.string), Generic$ApiTypes.Decode.fieldWithDefault("variantId", Curry._1(Generic$ApiTypes.Decode.option, Generic$ApiTypes.Decode.string), undefined), Generic$ApiTypes.Decode.fieldWithDefault("productCategoryId", Curry._1(Generic$ApiTypes.Decode.option, Generic$ApiTypes.Decode.string), undefined), (function (productId, variantId, productCategoryId) {
        return {
                productId: productId,
                variantId: variantId,
                productCategoryId: productCategoryId
              };
      }));

var storeCategoryLink_fromJson = Curry._5(Generic$ApiTypes.Decode.map4, Curry._2(Generic$ApiTypes.Decode.field, "categoryId", Generic$ApiTypes.Decode.string), Generic$ApiTypes.Decode.fieldWithDefault("sortBy", Store_ProductSortOrderCodecs$ApiTypes.ProductSortOrder.fromJson, /* Default */0), Curry._2(Generic$ApiTypes.Decode.field, "count", Generic$ApiTypes.Decode.$$int), Generic$ApiTypes.Decode.fieldWithDefault("relatedMediaCount", Curry._1(Generic$ApiTypes.Decode.option, Generic$ApiTypes.Decode.$$int), undefined), (function (categoryId, sortBy, count, relatedMediaCount) {
        return {
                categoryId: categoryId,
                sortBy: sortBy,
                count: count,
                relatedMediaCount: relatedMediaCount
              };
      }));

var customActionLink_fromJson = Curry._4(Generic$ApiTypes.Decode.map3, Curry._2(Generic$ApiTypes.Decode.field, "customActionId", CustomActionId$ApiTypes.fromJson), Curry._2(Generic$ApiTypes.Decode.field, "code", Generic$ApiTypes.Decode.string), Curry._2(Generic$ApiTypes.Decode.field, "name", Generic$ApiTypes.Decode.string), (function (customActionId, code, name) {
        return {
                customActionId: customActionId,
                code: code,
                name: name
              };
      }));

var fromJson$1 = Curry._2(Generic$ApiTypes.Decode.oneOf, Generic$ApiTypes.Decode.deccoVariantWithPayload("URL", Generic$ApiTypes.Decode.string, (function (str) {
            return {
                    TAG: /* URL */0,
                    _0: str
                  };
          })), [
      Generic$ApiTypes.Decode.deccoVariantWithPayload("Category", categoryLink_fromJson, (function (str) {
              return {
                      TAG: /* Category */1,
                      _0: str
                    };
            })),
      Generic$ApiTypes.Decode.deccoVariantWithPayload("Product", productLink_fromJson, (function (str) {
              return {
                      TAG: /* Product */2,
                      _0: str
                    };
            })),
      Generic$ApiTypes.Decode.deccoVariantWithPayload("StoreCategory", storeCategoryLink_fromJson, (function (str) {
              return {
                      TAG: /* StoreCategory */3,
                      _0: str
                    };
            })),
      Generic$ApiTypes.Decode.deccoVariantWithPayload("CustomAction", customActionLink_fromJson, (function (str) {
              return {
                      TAG: /* CustomAction */4,
                      _0: str
                    };
            }))
    ]);

var Link = {
  fromJson: fromJson$1
};

var videoCard_fromJson = Curry._8(Generic$ApiTypes.Decode.map7, Generic$ApiTypes.Decode.fieldWithDefault("link", Curry._1(Generic$ApiTypes.Decode.option, fromJson$1), undefined), Generic$ApiTypes.Decode.fieldWithDefault("size", fromJson, /* Lg */5), Generic$ApiTypes.Decode.fieldWithDefault("shape", LegacyShowside_BasicTypesDecoders$ApiTypes.cardShape_fromJson, /* Square */1), Curry._2(Generic$ApiTypes.Decode.field, "videoUrl", Generic$ApiTypes.Decode.string), Generic$ApiTypes.Decode.fieldWithDefault("width", Curry._1(Generic$ApiTypes.Decode.option, Generic$ApiTypes.Decode.$$int), undefined), Generic$ApiTypes.Decode.fieldWithDefault("height", Curry._1(Generic$ApiTypes.Decode.option, Generic$ApiTypes.Decode.$$int), undefined), Generic$ApiTypes.Decode.fieldWithDefault("fallbackImageUrl", Curry._1(Generic$ApiTypes.Decode.option, Generic$ApiTypes.Decode.string), undefined), (function (link, size, shape, videoUrl, width, height, fallbackImageUrl) {
        return {
                link: link,
                size: size,
                shape: shape,
                videoUrl: videoUrl,
                width: width,
                height: height,
                fallbackImageUrl: fallbackImageUrl
              };
      }));

var imageCard_fromJson = Curry._7(Generic$ApiTypes.Decode.map6, Generic$ApiTypes.Decode.fieldWithDefault("link", Curry._1(Generic$ApiTypes.Decode.option, fromJson$1), undefined), Generic$ApiTypes.Decode.fieldWithDefault("size", fromJson, /* Lg */5), Generic$ApiTypes.Decode.fieldWithDefault("shape", LegacyShowside_BasicTypesDecoders$ApiTypes.cardShape_fromJson, /* Square */1), Curry._2(Generic$ApiTypes.Decode.field, "imageUrl", Generic$ApiTypes.Decode.string), Generic$ApiTypes.Decode.fieldWithDefault("width", Curry._1(Generic$ApiTypes.Decode.option, Generic$ApiTypes.Decode.$$int), undefined), Generic$ApiTypes.Decode.fieldWithDefault("height", Curry._1(Generic$ApiTypes.Decode.option, Generic$ApiTypes.Decode.$$int), undefined), (function (link, size, shape, imageUrl, width, height) {
        return {
                link: link,
                size: size,
                shape: shape,
                imageUrl: imageUrl,
                width: width,
                height: height
              };
      }));

var imageLinkCard_fromJson = Curry._5(Generic$ApiTypes.Decode.map4, Curry._2(Generic$ApiTypes.Decode.field, "link", fromJson$1), Curry._2(Generic$ApiTypes.Decode.field, "imageUrl", Generic$ApiTypes.Decode.string), Generic$ApiTypes.Decode.fieldWithDefault("size", fromJson, /* Lg */5), Generic$ApiTypes.Decode.fieldWithDefault("shape", LegacyShowside_BasicTypesDecoders$ApiTypes.cardShape_fromJson, /* Square */1), (function (link, imageUrl, size, shape) {
        return {
                link: link,
                imageUrl: imageUrl,
                size: size,
                shape: shape
              };
      }));

var videoLinkCard_fromJson = Curry._6(Generic$ApiTypes.Decode.map5, Curry._2(Generic$ApiTypes.Decode.field, "link", fromJson$1), Curry._2(Generic$ApiTypes.Decode.field, "videoUrl", Generic$ApiTypes.Decode.string), Generic$ApiTypes.Decode.fieldWithDefault("size", fromJson, /* Lg */5), Generic$ApiTypes.Decode.fieldWithDefault("shape", LegacyShowside_BasicTypesDecoders$ApiTypes.cardShape_fromJson, /* Square */1), Generic$ApiTypes.Decode.fieldWithDefault("fallbackImageUrl", Curry._1(Generic$ApiTypes.Decode.option, Generic$ApiTypes.Decode.string), undefined), (function (link, videoUrl, size, shape, fallbackImageUrl) {
        return {
                link: link,
                videoUrl: videoUrl,
                size: size,
                shape: shape,
                fallbackImageUrl: fallbackImageUrl
              };
      }));

var medialessCard_fromJson = Curry._4(Generic$ApiTypes.Decode.map3, Curry._2(Generic$ApiTypes.Decode.field, "link", Curry._1(Generic$ApiTypes.Decode.option, fromJson$1)), Generic$ApiTypes.Decode.fieldWithDefault("size", fromJson, /* Lg */5), Generic$ApiTypes.Decode.fieldWithDefault("shape", LegacyShowside_BasicTypesDecoders$ApiTypes.cardShape_fromJson, /* Square */1), (function (link, size, shape) {
        return {
                link: link,
                size: size,
                shape: shape
              };
      }));

var medialessLinkCard_fromJson = Curry._4(Generic$ApiTypes.Decode.map3, Curry._2(Generic$ApiTypes.Decode.field, "link", fromJson$1), Generic$ApiTypes.Decode.fieldWithDefault("size", fromJson, /* Lg */5), Generic$ApiTypes.Decode.fieldWithDefault("shape", LegacyShowside_BasicTypesDecoders$ApiTypes.cardShape_fromJson, /* Square */1), (function (link, size, shape) {
        return {
                link: link,
                size: size,
                shape: shape
              };
      }));

var imageDisplayCard_fromJson = Curry._4(Generic$ApiTypes.Decode.map3, Curry._2(Generic$ApiTypes.Decode.field, "imageUrl", Generic$ApiTypes.Decode.string), Generic$ApiTypes.Decode.fieldWithDefault("size", fromJson, /* Lg */5), Generic$ApiTypes.Decode.fieldWithDefault("shape", LegacyShowside_BasicTypesDecoders$ApiTypes.cardShape_fromJson, /* Square */1), (function (imageUrl, size, shape) {
        return {
                imageUrl: imageUrl,
                size: size,
                shape: shape
              };
      }));

var videoDisplayCard_fromJson = Curry._5(Generic$ApiTypes.Decode.map4, Curry._2(Generic$ApiTypes.Decode.field, "videoUrl", Generic$ApiTypes.Decode.string), Generic$ApiTypes.Decode.fieldWithDefault("size", fromJson, /* Lg */5), Generic$ApiTypes.Decode.fieldWithDefault("shape", LegacyShowside_BasicTypesDecoders$ApiTypes.cardShape_fromJson, /* Square */1), Curry._2(Generic$ApiTypes.Decode.field, "fallbackImageUrl", Curry._1(Generic$ApiTypes.Decode.option, Generic$ApiTypes.Decode.string)), (function (videoUrl, size, shape, fallbackImageUrl) {
        return {
                videoUrl: videoUrl,
                size: size,
                shape: shape,
                fallbackImageUrl: fallbackImageUrl
              };
      }));

var fromJson$2 = Curry._2(Generic$ApiTypes.Decode.oneOf, Generic$ApiTypes.Decode.deccoVariantWithPayload("ImageLinkCard", imageLinkCard_fromJson, (function (payload) {
            return {
                    TAG: /* ImageLinkCard */0,
                    _0: payload
                  };
          })), [
      Generic$ApiTypes.Decode.deccoVariantWithPayload("VideoLinkCard", videoLinkCard_fromJson, (function (payload) {
              return {
                      TAG: /* VideoLinkCard */1,
                      _0: payload
                    };
            })),
      Generic$ApiTypes.Decode.deccoVariantWithPayload("ImageCard", imageCard_fromJson, (function (payload) {
              return {
                      TAG: /* ImageCard */2,
                      _0: payload
                    };
            })),
      Generic$ApiTypes.Decode.deccoVariantWithPayload("VideoCard", videoCard_fromJson, (function (payload) {
              return {
                      TAG: /* VideoCard */3,
                      _0: payload
                    };
            })),
      Generic$ApiTypes.Decode.deccoVariantWithPayload("MedialessCard", medialessCard_fromJson, (function (payload) {
              return {
                      TAG: /* MedialessCard */4,
                      _0: payload
                    };
            })),
      Generic$ApiTypes.Decode.deccoVariantWithPayload("MedialessLinkCard", medialessLinkCard_fromJson, (function (payload) {
              return {
                      TAG: /* MedialessLinkCard */5,
                      _0: payload
                    };
            })),
      Generic$ApiTypes.Decode.deccoVariantWithPayload("ImageDisplayCard", imageDisplayCard_fromJson, (function (payload) {
              return {
                      TAG: /* ImageDisplayCard */6,
                      _0: payload
                    };
            })),
      Generic$ApiTypes.Decode.deccoVariantWithPayload("VideoDisplayCard", videoDisplayCard_fromJson, (function (payload) {
              return {
                      TAG: /* VideoDisplayCard */7,
                      _0: payload
                    };
            }))
    ]);

var CategoryCard = {
  videoCard_fromJson: videoCard_fromJson,
  imageCard_fromJson: imageCard_fromJson,
  imageLinkCard_fromJson: imageLinkCard_fromJson,
  videoLinkCard_fromJson: videoLinkCard_fromJson,
  medialessCard_fromJson: medialessCard_fromJson,
  medialessLinkCard_fromJson: medialessLinkCard_fromJson,
  imageDisplayCard_fromJson: imageDisplayCard_fromJson,
  videoDisplayCard_fromJson: videoDisplayCard_fromJson,
  fromJson: fromJson$2
};

var storeCategoryConnection_fromJson = Curry._6(Generic$ApiTypes.Decode.map5, Curry._2(Generic$ApiTypes.Decode.field, "categoryId", Generic$ApiTypes.Decode.string), Curry._2(Generic$ApiTypes.Decode.field, "sortBy", Store_ProductSortOrderDecoders$ApiTypes.ProductSortOrder.fromJson), Generic$ApiTypes.Decode.fieldWithDefault("filterBy", Curry._1(Generic$ApiTypes.Decode.option, Curry._1(Generic$ApiTypes.Decode.array, Generic$ApiTypes.Decode.string)), undefined), Curry._2(Generic$ApiTypes.Decode.field, "count", Generic$ApiTypes.Decode.$$int), Generic$ApiTypes.Decode.fieldWithDefault("relatedMediaCount", Curry._1(Generic$ApiTypes.Decode.option, Generic$ApiTypes.Decode.$$int), undefined), (function (categoryId, sortBy, filterBy, count, relatedMediaCount) {
        return {
                categoryId: categoryId,
                sortBy: sortBy,
                filterBy: filterBy,
                count: count,
                relatedMediaCount: relatedMediaCount
              };
      }));

var configEmbedConnection_fromJson = Curry._2(Generic$ApiTypes.Decode.map, Curry._2(Generic$ApiTypes.Decode.field, "configId", Generic$ApiTypes.Decode.string), (function (configId) {
        return {
                configId: configId
              };
      }));

var fromJson$3 = Curry._2(Generic$ApiTypes.Decode.oneOf, Generic$ApiTypes.Decode.deccoVariantWithPayload("StoreCategory", storeCategoryConnection_fromJson, (function (payload) {
            return {
                    TAG: /* StoreCategory */0,
                    _0: payload
                  };
          })), [
      Generic$ApiTypes.Decode.deccoVariantWithPayload("ConfigEmbed", configEmbedConnection_fromJson, (function (payload) {
              return {
                      TAG: /* ConfigEmbed */1,
                      _0: payload
                    };
            })),
      Generic$ApiTypes.Decode.simpleVariant([[
              "History",
              /* History */0
            ]]),
      Generic$ApiTypes.Decode.simpleVariant([[
              "Favorites",
              /* Favorites */1
            ]]),
      Generic$ApiTypes.Decode.simpleVariant([[
              "StoreCart",
              /* StoreCart */2
            ]])
    ]);

var t_v1_fromJson = Curry._2(Generic$ApiTypes.Decode.andThen, storeCategoryConnection_fromJson, (function (connection) {
        return Curry._1(Generic$ApiTypes.Decode.succeed, {
                    TAG: /* StoreCategory */0,
                    _0: connection
                  });
      }));

var fromJson$4 = Json__Decode.oneOf(fromJson$3, [t_v1_fromJson]);

var ExternalConnection = {
  storeCategoryConnection_fromJson: storeCategoryConnection_fromJson,
  configEmbedConnection_fromJson: configEmbedConnection_fromJson,
  t_v1_fromJson: t_v1_fromJson,
  fromJson: fromJson$4
};

var layout_fromJson = Curry._2(Generic$ApiTypes.Decode.oneOf, Generic$ApiTypes.Decode.deccoVariantWithPayload("SubCategoriesSlider", LegacyShowside_BasicTypesDecoders$ApiTypes.sliderPayload_fromJson, (function (payload) {
            return {
                    TAG: /* SubCategoriesSlider */0,
                    _0: payload
                  };
          })), [
      Generic$ApiTypes.Decode.deccoVariantWithPayload("SubCategoriesSliderWithHeader", LegacyShowside_BasicTypesDecoders$ApiTypes.sliderPayload_fromJson, (function (payload) {
              return {
                      TAG: /* SubCategoriesSliderWithHeader */1,
                      _0: payload
                    };
            })),
      Generic$ApiTypes.Decode.deccoVariantWithPayload("SubCategoriesGrid", LegacyShowside_BasicTypesDecoders$ApiTypes.gridPayload_fromJson, (function (payload) {
              return {
                      TAG: /* SubCategoriesGrid */2,
                      _0: payload
                    };
            })),
      Generic$ApiTypes.Decode.deccoVariantWithPayload("ProductGrid", LegacyShowside_BasicTypesDecoders$ApiTypes.gridPayload_fromJson, (function (payload) {
              return {
                      TAG: /* ProductGrid */3,
                      _0: payload
                    };
            })),
      Generic$ApiTypes.Decode.deccoVariantWithPayload("ProductSlider", LegacyShowside_BasicTypesDecoders$ApiTypes.sliderPayload_fromJson, (function (payload) {
              return {
                      TAG: /* ProductSlider */4,
                      _0: payload
                    };
            })),
      Generic$ApiTypes.Decode.simpleVariant([[
              "NoLayout",
              /* NoLayout */0
            ]])
    ]);

var linkCategory_fromJson = Curry._4(Generic$ApiTypes.Decode.map3, Curry._2(Generic$ApiTypes.Decode.field, "link", Generic$ApiTypes.Decode.string), Generic$ApiTypes.Decode.fieldWithDefault("imageWidth", Curry._1(Generic$ApiTypes.Decode.option, Generic$ApiTypes.Decode.$$int), undefined), Generic$ApiTypes.Decode.fieldWithDefault("imageHeight", Curry._1(Generic$ApiTypes.Decode.option, Generic$ApiTypes.Decode.$$int), undefined), (function (link, imageWidth, imageHeight) {
        return {
                link: link,
                imageWidth: imageWidth,
                imageHeight: imageHeight
              };
      }));

function fromJson$5(param) {
  return Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._1(Generic$ApiTypes.Decode.succeed, (function (id, title, description, showTitle, showDescription, visible, visibleInMenuBar, visibleInSectionList, visibleInParent, visibleInHeaderSlider, listPageActiveLayout, userSelectedLayout, forcedPLPLayout, tabbedSubCategories, card, categoryType, socialNetworkSource, displayPriority, expandVariantsInProductsListing, lastModifiedAt, sectionTheme, pageTheme, stickySection) {
                                                                                                            return {
                                                                                                                    id: id,
                                                                                                                    title: title,
                                                                                                                    description: description,
                                                                                                                    showTitle: showTitle,
                                                                                                                    showDescription: showDescription,
                                                                                                                    visible: visible,
                                                                                                                    visibleInMenuBar: visibleInMenuBar,
                                                                                                                    visibleInSectionList: visibleInSectionList,
                                                                                                                    visibleInParent: visibleInParent,
                                                                                                                    visibleInHeaderSlider: visibleInHeaderSlider,
                                                                                                                    listPageActiveLayout: listPageActiveLayout,
                                                                                                                    userSelectedLayout: userSelectedLayout,
                                                                                                                    forcedPLPLayout: forcedPLPLayout,
                                                                                                                    tabbedSubCategories: tabbedSubCategories,
                                                                                                                    card: card,
                                                                                                                    categoryType: categoryType,
                                                                                                                    socialNetworkSource: socialNetworkSource,
                                                                                                                    displayPriority: displayPriority,
                                                                                                                    expandVariantsInProductsListing: expandVariantsInProductsListing,
                                                                                                                    lastModifiedAt: lastModifiedAt,
                                                                                                                    sectionTheme: sectionTheme,
                                                                                                                    pageTheme: pageTheme,
                                                                                                                    stickySection: stickySection
                                                                                                                  };
                                                                                                          })), Curry._2(Generic$ApiTypes.Decode.field, "id", Generic$ApiTypes.Decode.string)), Generic$ApiTypes.Decode.fieldWithDefault("title", Generic$ApiTypes.Decode.string, "")), Generic$ApiTypes.Decode.fieldWithDefault("description", Curry._1(Generic$ApiTypes.Decode.option, Generic$ApiTypes.Decode.string), undefined)), Generic$ApiTypes.Decode.fieldWithDefault("showTitle", Generic$ApiTypes.Decode.bool, true)), Generic$ApiTypes.Decode.fieldWithDefault("showDescription", Generic$ApiTypes.Decode.bool, true)), Generic$ApiTypes.Decode.fieldWithDefault("visible", Generic$ApiTypes.Decode.bool, true)), Generic$ApiTypes.Decode.fieldWithDefault("visibleInMenuBar", Generic$ApiTypes.Decode.bool, true)), Generic$ApiTypes.Decode.fieldWithDefault("visibleInSectionList", Generic$ApiTypes.Decode.bool, true)), Generic$ApiTypes.Decode.fieldWithDefault("visibleInParent", Generic$ApiTypes.Decode.bool, true)), Generic$ApiTypes.Decode.fieldWithDefault("visibleInHeaderSlider", Generic$ApiTypes.Decode.bool, true)), Generic$ApiTypes.Decode.fieldWithDefault("listPageActiveLayout", layout_fromJson, /* NoLayout */0)), Generic$ApiTypes.Decode.fieldWithDefault("userSelectedLayout", layout_fromJson, /* NoLayout */0)), Generic$ApiTypes.Decode.fieldWithDefault("forcedPLPLayout", layout_fromJson, /* NoLayout */0)), Generic$ApiTypes.Decode.fieldWithDefault("tabbedSubCategories", Curry._1(Generic$ApiTypes.Decode.option, Tree_CategoryTabSettingsCodecs$ApiTypes.CategoryTabSettings.fromJson), undefined)), Curry._2(Generic$ApiTypes.Decode.field, "card", fromJson$2)), Curry._2(Generic$ApiTypes.Decode.field, "categoryType", categoryType_fromJson(undefined))), Generic$ApiTypes.Decode.fieldWithDefault("socialNetworkSource", Curry._1(Generic$ApiTypes.Decode.option, Tree_SocialNetworkSourceCodecs$ApiTypes.SocialNetworkSource.fromJson), undefined)), Generic$ApiTypes.Decode.fieldWithDefault("displayPriority", Tree_DisplayPriorityCodecs$ApiTypes.DisplayPriority.fromJson, /* ChildrenFirst */0)), Generic$ApiTypes.Decode.fieldWithDefault("expandVariantsInProductsListing", Curry._1(Generic$ApiTypes.Decode.option, Generic$ApiTypes.Decode.bool), undefined)), Generic$ApiTypes.Decode.fieldWithDefault("lastModifiedAt", Curry._1(Generic$ApiTypes.Decode.option, Generic$ApiTypes.Decode.$$float), undefined)), Generic$ApiTypes.Decode.fieldWithDefault("sectionTheme", ThemeDecoders$ApiTypes.reference_fromJson, /* LegacyTheme */0)), Generic$ApiTypes.Decode.fieldWithDefault("pageTheme", ThemeDecoders$ApiTypes.reference_fromJson, /* LegacyTheme */0)), Generic$ApiTypes.Decode.fieldWithDefault("stickySection", Generic$ApiTypes.Decode.bool, false));
}

function category_fromJson(param) {
  return Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._1(Generic$ApiTypes.Decode.succeed, (function (firstCard, externalConnection, children, loadMoreChildren, totalChildren, link, products, taggedMedia, imageHotspots, imageWidth, imageHeight) {
                                                            return {
                                                                    firstCard: firstCard,
                                                                    externalConnection: externalConnection,
                                                                    children: children,
                                                                    loadMoreChildren: loadMoreChildren,
                                                                    totalChildren: totalChildren,
                                                                    link: link,
                                                                    products: products,
                                                                    taggedMedia: taggedMedia,
                                                                    imageHotspots: imageHotspots,
                                                                    imageWidth: imageWidth,
                                                                    imageHeight: imageHeight
                                                                  };
                                                          })), Generic$ApiTypes.Decode.fieldWithDefault("firstCard", Curry._1(Generic$ApiTypes.Decode.option, fromJson$2), undefined)), Generic$ApiTypes.Decode.fieldWithDefault("externalConnection", Curry._1(Generic$ApiTypes.Decode.option, fromJson$4), undefined)), Curry._2(Generic$ApiTypes.Decode.field, "children", Curry._1(Generic$ApiTypes.Decode.array, Generic$ApiTypes.Decode.lazy_(function (param) {
                                                          return fromJson$5(undefined);
                                                        })))), Generic$ApiTypes.Decode.fieldWithDefault("loadMoreChildren", Curry._1(Generic$ApiTypes.Decode.option, Generic$ApiTypes.Decode.string), undefined)), Generic$ApiTypes.Decode.fieldWithDefault("totalChildren", Generic$ApiTypes.Decode.$$int, 0)), Generic$ApiTypes.Decode.fieldWithDefault("link", Curry._1(Generic$ApiTypes.Decode.option, Generic$ApiTypes.Decode.string), undefined)), Generic$ApiTypes.Decode.fieldWithDefault("products", Tree_TaggedProductsCodecs$ApiTypes.TaggedProducts.fromJson, [])), Generic$ApiTypes.Decode.fieldWithDefault("taggedMedia", Curry._1(Generic$ApiTypes.Decode.option, taggedMedia_fromJson(undefined)), undefined)), Generic$ApiTypes.Decode.fieldWithDefault("imageHotspots", Curry._1(Generic$ApiTypes.Decode.option, Curry._1(Generic$ApiTypes.Decode.array, QuickViewPinCodecs$ApiTypes.fromJson)), undefined)), Generic$ApiTypes.Decode.fieldWithDefault("imageWidth", Curry._1(Generic$ApiTypes.Decode.option, Generic$ApiTypes.Decode.$$int), undefined)), Generic$ApiTypes.Decode.fieldWithDefault("imageHeight", Curry._1(Generic$ApiTypes.Decode.option, Generic$ApiTypes.Decode.$$int), undefined));
}

function taggedMediaSource_fromJson(param) {
  return Json__Decode.oneOf(Generic$ApiTypes.Decode.deccoVariantWithPayload("Manual", Json__Decode.array(Generic$ApiTypes.Decode.lazy_(function (param) {
                          return fromJson$5(undefined);
                        })), (function (payload) {
                    return /* Manual */{
                            _0: payload
                          };
                  })), []);
}

function taggedMedia_fromJson(param) {
  return Curry._8(Generic$ApiTypes.Decode.map7, Curry._2(Generic$ApiTypes.Decode.field, "source", taggedMediaSource_fromJson(undefined)), Generic$ApiTypes.Decode.fieldWithDefault("displayType", Tree_TaggedMediaCodecs$ApiTypes.TaggedMedia.displayType_fromJson, /* InlineDisplay */0), Generic$ApiTypes.Decode.fieldWithDefault("cardWidth", Curry._1(Generic$ApiTypes.Decode.option, Generic$ApiTypes.Decode.$$int), undefined), Generic$ApiTypes.Decode.fieldWithDefault("cardHeight", Curry._1(Generic$ApiTypes.Decode.option, Generic$ApiTypes.Decode.$$int), undefined), Generic$ApiTypes.Decode.fieldWithDefault("startRowOffset", Curry._1(Generic$ApiTypes.Decode.option, Generic$ApiTypes.Decode.$$int), undefined), Generic$ApiTypes.Decode.fieldWithDefault("slidesPerView", Curry._1(Generic$ApiTypes.Decode.option, Generic$ApiTypes.Decode.$$float), undefined), Generic$ApiTypes.Decode.fieldWithDefault("imageFit", Tree_TaggedMediaCodecs$ApiTypes.TaggedMedia.imageFit_fromJson, /* FitCover */0), (function (source, displayType, cardWidth, cardHeight, startRowOffset, slidesPerView, imageFit) {
                return {
                        source: source,
                        displayType: displayType,
                        cardWidth: cardWidth,
                        cardHeight: cardHeight,
                        startRowOffset: startRowOffset,
                        slidesPerView: slidesPerView,
                        imageFit: imageFit
                      };
              }));
}

function quickviewCategory_fromJson(param) {
  return Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._1(Generic$ApiTypes.Decode.succeed, (function (isStories, isPinned, firstCard, externalConnection, children, loadMoreChildren, totalChildren, link, products, imageHotspots, imageWidth, imageHeight) {
                                                                return {
                                                                        isStories: isStories,
                                                                        isPinned: isPinned,
                                                                        firstCard: firstCard,
                                                                        externalConnection: externalConnection,
                                                                        children: children,
                                                                        loadMoreChildren: loadMoreChildren,
                                                                        totalChildren: totalChildren,
                                                                        link: link,
                                                                        products: products,
                                                                        imageHotspots: imageHotspots,
                                                                        imageWidth: imageWidth,
                                                                        imageHeight: imageHeight
                                                                      };
                                                              })), Generic$ApiTypes.Decode.fieldWithDefault("isStories", Generic$ApiTypes.Decode.bool, false)), Generic$ApiTypes.Decode.fieldWithDefault("isPinned", Generic$ApiTypes.Decode.bool, false)), Generic$ApiTypes.Decode.fieldWithDefault("firstCard", Curry._1(Generic$ApiTypes.Decode.option, fromJson$2), undefined)), Generic$ApiTypes.Decode.fieldWithDefault("externalConnection", Curry._1(Generic$ApiTypes.Decode.option, fromJson$4), undefined)), Curry._2(Generic$ApiTypes.Decode.field, "children", Curry._1(Generic$ApiTypes.Decode.array, Generic$ApiTypes.Decode.lazy_(function (param) {
                                                      return fromJson$5(undefined);
                                                    })))), Generic$ApiTypes.Decode.fieldWithDefault("loadMoreChildren", Curry._1(Generic$ApiTypes.Decode.option, Generic$ApiTypes.Decode.string), undefined)), Generic$ApiTypes.Decode.fieldWithDefault("totalChildren", Generic$ApiTypes.Decode.$$int, 0)), Generic$ApiTypes.Decode.fieldWithDefault("link", Curry._1(Generic$ApiTypes.Decode.option, Generic$ApiTypes.Decode.string), undefined)), Generic$ApiTypes.Decode.fieldWithDefault("products", Tree_TaggedProductsCodecs$ApiTypes.TaggedProducts.fromJson, [])), Generic$ApiTypes.Decode.fieldWithDefault("imageHotspots", Curry._1(Generic$ApiTypes.Decode.option, Curry._1(Generic$ApiTypes.Decode.array, QuickViewPinCodecs$ApiTypes.fromJson)), undefined)), Generic$ApiTypes.Decode.fieldWithDefault("imageWidth", Curry._1(Generic$ApiTypes.Decode.option, Generic$ApiTypes.Decode.$$int), undefined)), Generic$ApiTypes.Decode.fieldWithDefault("imageHeight", Curry._1(Generic$ApiTypes.Decode.option, Generic$ApiTypes.Decode.$$int), undefined));
}

function indexCategory_fromJson(param) {
  return Curry._4(Generic$ApiTypes.Decode.map3, Generic$ApiTypes.Decode.fieldWithDefault("externalConnection", Curry._1(Generic$ApiTypes.Decode.option, fromJson$4), undefined), Generic$ApiTypes.Decode.fieldWithDefault("taggedMedia", Curry._1(Generic$ApiTypes.Decode.option, taggedMedia_fromJson(undefined)), undefined), Generic$ApiTypes.Decode.fieldWithDefault("products", Tree_TaggedProductsCodecs$ApiTypes.TaggedProducts.fromJson, []), (function (externalConnection, taggedMedia, products) {
                return {
                        externalConnection: externalConnection,
                        taggedMedia: taggedMedia,
                        products: products
                      };
              }));
}

function customComponentCategory_fromJson(param) {
  return Curry._2(Generic$ApiTypes.Decode.andMap, Curry._1(Generic$ApiTypes.Decode.succeed, (function (component) {
                    return {
                            component: component
                          };
                  })), Curry._2(Generic$ApiTypes.Decode.field, "component", CustomComponentCodecs$ApiTypes.reference_fromJson));
}

function configEmbedCategory_fromJson(param) {
  return Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._1(Generic$ApiTypes.Decode.succeed, (function (firstCard, configId, children, loadMoreChildren, totalChildren, link, products, taggedMedia, imageHotspots, imageWidth, imageHeight) {
                                                            return {
                                                                    firstCard: firstCard,
                                                                    configId: configId,
                                                                    children: children,
                                                                    loadMoreChildren: loadMoreChildren,
                                                                    totalChildren: totalChildren,
                                                                    link: link,
                                                                    products: products,
                                                                    taggedMedia: taggedMedia,
                                                                    imageHotspots: imageHotspots,
                                                                    imageWidth: imageWidth,
                                                                    imageHeight: imageHeight
                                                                  };
                                                          })), Generic$ApiTypes.Decode.fieldWithDefault("firstCard", Curry._1(Generic$ApiTypes.Decode.option, fromJson$2), undefined)), Curry._2(Generic$ApiTypes.Decode.field, "configId", Generic$ApiTypes.Decode.string)), Curry._2(Generic$ApiTypes.Decode.field, "children", Curry._1(Generic$ApiTypes.Decode.array, Generic$ApiTypes.Decode.lazy_(function (param) {
                                                          return fromJson$5(undefined);
                                                        })))), Generic$ApiTypes.Decode.fieldWithDefault("loadMoreChildren", Curry._1(Generic$ApiTypes.Decode.option, Generic$ApiTypes.Decode.string), undefined)), Generic$ApiTypes.Decode.fieldWithDefault("totalChildren", Generic$ApiTypes.Decode.$$int, 0)), Generic$ApiTypes.Decode.fieldWithDefault("link", Curry._1(Generic$ApiTypes.Decode.option, Generic$ApiTypes.Decode.string), undefined)), Generic$ApiTypes.Decode.fieldWithDefault("products", Tree_TaggedProductsCodecs$ApiTypes.TaggedProducts.fromJson, [])), Generic$ApiTypes.Decode.fieldWithDefault("taggedMedia", Curry._1(Generic$ApiTypes.Decode.option, taggedMedia_fromJson(undefined)), undefined)), Generic$ApiTypes.Decode.fieldWithDefault("imageHotspots", Curry._1(Generic$ApiTypes.Decode.option, Curry._1(Generic$ApiTypes.Decode.array, QuickViewPinCodecs$ApiTypes.fromJson)), undefined)), Generic$ApiTypes.Decode.fieldWithDefault("imageWidth", Curry._1(Generic$ApiTypes.Decode.option, Generic$ApiTypes.Decode.$$int), undefined)), Generic$ApiTypes.Decode.fieldWithDefault("imageHeight", Curry._1(Generic$ApiTypes.Decode.option, Generic$ApiTypes.Decode.$$int), undefined));
}

function categoryType_fromJson(param) {
  return Curry._2(Generic$ApiTypes.Decode.oneOf, Generic$ApiTypes.Decode.deccoVariantWithPayload("Link", linkCategory_fromJson, (function (payload) {
                    return {
                            TAG: /* Link */0,
                            _0: payload
                          };
                  })), [
              Generic$ApiTypes.Decode.deccoVariantWithPayload("Standard", category_fromJson(undefined), (function (payload) {
                      return {
                              TAG: /* Standard */1,
                              _0: payload
                            };
                    })),
              Generic$ApiTypes.Decode.deccoVariantWithPayload("QuickView", quickviewCategory_fromJson(undefined), (function (payload) {
                      return {
                              TAG: /* QuickView */2,
                              _0: payload
                            };
                    })),
              Generic$ApiTypes.Decode.deccoVariantWithPayload("Index", indexCategory_fromJson(undefined), (function (payload) {
                      return {
                              TAG: /* Index */3,
                              _0: payload
                            };
                    })),
              Generic$ApiTypes.Decode.deccoVariantWithPayload("ConfigEmbed", configEmbedCategory_fromJson(undefined), (function (payload) {
                      return {
                              TAG: /* ConfigEmbed */4,
                              _0: payload
                            };
                    })),
              Generic$ApiTypes.Decode.simpleVariant([[
                      "Page",
                      /* Page */0
                    ]]),
              Generic$ApiTypes.Decode.deccoVariantWithPayload("CustomComponentSection", customComponentCategory_fromJson(undefined), (function (payload) {
                      return {
                              TAG: /* CustomComponentSection */5,
                              _0: payload
                            };
                    })),
              Generic$ApiTypes.Decode.deccoVariantWithPayload("EmbedCodeSection", EmbedCodeCodecs$ApiTypes.t_decode, (function (payload) {
                      return {
                              TAG: /* EmbedCodeSection */6,
                              _0: payload
                            };
                    }))
            ]);
}

var fromJson$6 = Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._1(Generic$ApiTypes.Decode.succeed, (function (id, title, description, showTitle, showDescription, visible, visibleInMenuBar, visibleInSectionList, visibleInParent, visibleInHeaderSlider, listPageActiveLayout, userSelectedLayout, forcedPLPLayout, tabbedSubCategories, card, categoryType, socialNetworkSource, displayPriority, expandVariantsInProductsListing, lastModifiedAt, sectionTheme, pageTheme, stickySection) {
                                                                                                    return {
                                                                                                            id: id,
                                                                                                            title: title,
                                                                                                            description: description,
                                                                                                            showTitle: showTitle,
                                                                                                            showDescription: showDescription,
                                                                                                            visible: visible,
                                                                                                            visibleInMenuBar: visibleInMenuBar,
                                                                                                            visibleInSectionList: visibleInSectionList,
                                                                                                            visibleInParent: visibleInParent,
                                                                                                            visibleInHeaderSlider: visibleInHeaderSlider,
                                                                                                            listPageActiveLayout: listPageActiveLayout,
                                                                                                            userSelectedLayout: userSelectedLayout,
                                                                                                            forcedPLPLayout: forcedPLPLayout,
                                                                                                            tabbedSubCategories: tabbedSubCategories,
                                                                                                            card: card,
                                                                                                            categoryType: categoryType,
                                                                                                            socialNetworkSource: socialNetworkSource,
                                                                                                            displayPriority: displayPriority,
                                                                                                            expandVariantsInProductsListing: expandVariantsInProductsListing,
                                                                                                            lastModifiedAt: lastModifiedAt,
                                                                                                            sectionTheme: sectionTheme,
                                                                                                            pageTheme: pageTheme,
                                                                                                            stickySection: stickySection
                                                                                                          };
                                                                                                  })), Curry._2(Generic$ApiTypes.Decode.field, "id", Generic$ApiTypes.Decode.string)), Generic$ApiTypes.Decode.fieldWithDefault("title", Generic$ApiTypes.Decode.string, "")), Generic$ApiTypes.Decode.fieldWithDefault("description", Curry._1(Generic$ApiTypes.Decode.option, Generic$ApiTypes.Decode.string), undefined)), Generic$ApiTypes.Decode.fieldWithDefault("showTitle", Generic$ApiTypes.Decode.bool, true)), Generic$ApiTypes.Decode.fieldWithDefault("showDescription", Generic$ApiTypes.Decode.bool, true)), Generic$ApiTypes.Decode.fieldWithDefault("visible", Generic$ApiTypes.Decode.bool, true)), Generic$ApiTypes.Decode.fieldWithDefault("visibleInMenuBar", Generic$ApiTypes.Decode.bool, true)), Generic$ApiTypes.Decode.fieldWithDefault("visibleInSectionList", Generic$ApiTypes.Decode.bool, true)), Generic$ApiTypes.Decode.fieldWithDefault("visibleInParent", Generic$ApiTypes.Decode.bool, true)), Generic$ApiTypes.Decode.fieldWithDefault("visibleInHeaderSlider", Generic$ApiTypes.Decode.bool, true)), Generic$ApiTypes.Decode.fieldWithDefault("listPageActiveLayout", layout_fromJson, /* NoLayout */0)), Generic$ApiTypes.Decode.fieldWithDefault("userSelectedLayout", layout_fromJson, /* NoLayout */0)), Generic$ApiTypes.Decode.fieldWithDefault("forcedPLPLayout", layout_fromJson, /* NoLayout */0)), Generic$ApiTypes.Decode.fieldWithDefault("tabbedSubCategories", Curry._1(Generic$ApiTypes.Decode.option, Tree_CategoryTabSettingsCodecs$ApiTypes.CategoryTabSettings.fromJson), undefined)), Curry._2(Generic$ApiTypes.Decode.field, "card", fromJson$2)), Curry._2(Generic$ApiTypes.Decode.field, "categoryType", categoryType_fromJson(undefined))), Generic$ApiTypes.Decode.fieldWithDefault("socialNetworkSource", Curry._1(Generic$ApiTypes.Decode.option, Tree_SocialNetworkSourceCodecs$ApiTypes.SocialNetworkSource.fromJson), undefined)), Generic$ApiTypes.Decode.fieldWithDefault("displayPriority", Tree_DisplayPriorityCodecs$ApiTypes.DisplayPriority.fromJson, /* ChildrenFirst */0)), Generic$ApiTypes.Decode.fieldWithDefault("expandVariantsInProductsListing", Curry._1(Generic$ApiTypes.Decode.option, Generic$ApiTypes.Decode.bool), undefined)), Generic$ApiTypes.Decode.fieldWithDefault("lastModifiedAt", Curry._1(Generic$ApiTypes.Decode.option, Generic$ApiTypes.Decode.$$float), undefined)), Generic$ApiTypes.Decode.fieldWithDefault("sectionTheme", ThemeDecoders$ApiTypes.reference_fromJson, /* LegacyTheme */0)), Generic$ApiTypes.Decode.fieldWithDefault("pageTheme", ThemeDecoders$ApiTypes.reference_fromJson, /* LegacyTheme */0)), Generic$ApiTypes.Decode.fieldWithDefault("stickySection", Generic$ApiTypes.Decode.bool, false));

var fromJson$7 = Curry._6(Generic$ApiTypes.Decode.map5, Curry._2(Generic$ApiTypes.Decode.field, "categories", Curry._1(Generic$ApiTypes.Decode.array, fromJson$6)), Curry._2(Generic$ApiTypes.Decode.field, "previous", Curry._1(Generic$ApiTypes.Decode.option, Generic$ApiTypes.Decode.string)), Curry._2(Generic$ApiTypes.Decode.field, "next", Curry._1(Generic$ApiTypes.Decode.option, Generic$ApiTypes.Decode.string)), Generic$ApiTypes.Decode.fieldWithDefault("offset", Generic$ApiTypes.Decode.$$int, 0), Generic$ApiTypes.Decode.fieldWithDefault("total", Generic$ApiTypes.Decode.$$int, 0), (function (categories, previous, next, offset, total) {
        return {
                categories: categories,
                previous: previous,
                next: next,
                offset: offset,
                total: total
              };
      }));

var Page = {
  fromJson: fromJson$7
};

var empty = {
  id: "",
  title: "",
  description: undefined,
  showTitle: true,
  showDescription: true,
  visible: true,
  visibleInMenuBar: true,
  visibleInSectionList: true,
  visibleInParent: true,
  visibleInHeaderSlider: true,
  listPageActiveLayout: {
    TAG: /* SubCategoriesGrid */2,
    _0: {
      columns: /* FourColumnGrid */3,
      gap: /* Equal */0,
      maxRows: undefined,
      maxWidth: undefined,
      padding: undefined,
      pattern: undefined
    }
  },
  userSelectedLayout: {
    TAG: /* SubCategoriesGrid */2,
    _0: {
      columns: /* FourColumnGrid */3,
      gap: /* Equal */0,
      maxRows: undefined,
      maxWidth: undefined,
      padding: undefined,
      pattern: undefined
    }
  },
  forcedPLPLayout: {
    TAG: /* ProductGrid */3,
    _0: {
      columns: /* FourColumnGrid */3,
      gap: /* Equal */0,
      maxRows: undefined,
      maxWidth: undefined,
      padding: undefined,
      pattern: undefined
    }
  },
  tabbedSubCategories: undefined,
  card: {
    TAG: /* ImageLinkCard */0,
    _0: {
      link: {
        TAG: /* URL */0,
        _0: ""
      },
      imageUrl: "",
      size: /* Md */4,
      shape: /* Square */1
    }
  },
  categoryType: {
    TAG: /* Link */0,
    _0: {
      link: "",
      imageWidth: undefined,
      imageHeight: undefined
    }
  },
  socialNetworkSource: undefined,
  displayPriority: /* ChildrenFirst */0,
  expandVariantsInProductsListing: undefined,
  lastModifiedAt: undefined,
  sectionTheme: /* LegacyTheme */0,
  pageTheme: /* LegacyTheme */0,
  stickySection: false
};

export {
  CardSize ,
  Link ,
  CategoryCard ,
  ExternalConnection ,
  layout_fromJson ,
  linkCategory_fromJson ,
  category_fromJson ,
  taggedMediaSource_fromJson ,
  taggedMedia_fromJson ,
  quickviewCategory_fromJson ,
  indexCategory_fromJson ,
  customComponentCategory_fromJson ,
  configEmbedCategory_fromJson ,
  categoryType_fromJson ,
  fromJson$6 as fromJson,
  Page ,
  empty ,
}
/* fromJson Not a pure module */
